import React from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { MainRouter } from "./routes/Router";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
      <MainRouter />
      <ToastContainer />
    </>
  );
}

export default App;
